module.exports = __webpack_public_path__ + "img/151-02c9f4.png";